import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function ProductDemoCTA() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact", { state: { source: "product-demo" } });
  };

  return (
    <section className="relative max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
      {/* Background Decorative Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-blue-600/15 blur-[80px] md:blur-[120px] rounded-full -z-10" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative overflow-hidden bg-[#161B22]/60 backdrop-blur-xl border border-white/10 rounded-[20px] md:rounded-[40px] p-8 md:p-10 lg:p-20 text-center shadow-2xl">
        {/* Subtle Inner Glow */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00BCF0]/20 to-transparent" />

        <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-white mb-4 md:mb-6 tracking-tighter uppercase italic leading-tight px-2">
          Power Your Business with <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00BCF0] to-[#007BFF]">
            Our Products
          </span>
        </h2>

        <p className="text-slate-400 text-sm md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed px-2">
          Discover our comprehensive suite of enterprise solutions designed to
          streamline operations and accelerate growth.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleClick}
            className="group relative px-10 py-4 bg-gradient-to-r from-[#05DFAD] to-[#007BFF] rounded-xl text-white font-bold uppercase tracking-widest text-sm hover:opacity-90 transition-all shadow-lg hover:shadow-[0_0_30px_rgba(5,223,173,0.4)]">
            Start Your Project
            <div className="absolute inset-0 rounded-xl bg-white opacity-0 group-hover:opacity-20 transition-opacity" />
          </button>

          {/* <Link
            to="/products"
            className="group relative px-10 py-4 border-2 border-[#00BCF0] rounded-xl text-[#00BCF0] font-bold uppercase tracking-widest text-sm hover:bg-[#00BCF0] hover:text-white transition-all">
            Browse All Products
            <div className="absolute inset-0 rounded-xl bg-[#00BCF0] opacity-0 group-hover:opacity-100 transition-opacity" />
          </Link> */}
        </div>

        {/* Product Features */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 pt-8 border-t border-white/10">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-black text-[#00BCF0] mb-2">
              Industry
            </div>
            <div className="text-slate-400 text-sm uppercase tracking-wider">
              Solutions
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-black text-[#00BCF0] mb-2">
              Uptime
            </div>
            <div className="text-slate-400 text-sm uppercase tracking-wider">
              Guaranteed
            </div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-black text-[#00BCF0] mb-2">
              Technical
            </div>
            <div className="text-slate-400 text-sm uppercase tracking-wider">
              Support
            </div>
          </div>
        </div>

        {/* Floating Decorative Elements */}
        <div className="hidden lg:block absolute -bottom-10 -left-10 w-40 h-40 bg-blue-500/10 blur-3xl rounded-full" />
        <div className="hidden lg:block absolute -top-10 -right-10 w-40 h-40 bg-cyan-500/10 blur-3xl rounded-full" />
      </motion.div>
    </section>
  );
}
